import React, {useEffect} from "react";
import {getSaleDeptId} from "pages/salesDeptPlan/api";
import {Box, FormControl, InputLabel, NativeSelect} from "@material-ui/core";
import CustomButton from "../../components/UI/Button";
import {useDispatch} from "react-redux";
import {setShowModal} from "../../services/redux/actions/app-actions";
import {MODALS} from "../../constants";
import cookiesService from "../../services/cookiesService";

const cookiesServiceInstance = cookiesService.getService();
const Filters = ({
  state,
  handleChange,
  type,
  hunterTypes = [],
  kpiHunterTypeId,
  saleDepartmentId,
  saleDept = [],
  setSaleDept,
  coeffList = [],
}) => {
  const { position_code } = cookiesServiceInstance.getUserData();
  const dispatch = useDispatch();
  useEffect(() => {
    getSaleDeptId().then((res) => {
      if (setSaleDept) setSaleDept(res || []);
    });
  }, [setSaleDept]);
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        gap: "20px",
        margin: "20px 0",
      }}
    >
      <Box sx={{ minWidth: 200 }}>
        <CustomButton
          btnText="Добавить коэффициент"
          handleClick={() => {
            dispatch(
              setShowModal(true, MODALS.addCoeffModal, {
                title: "Добавить коэффициент",
                state: state,
                type: type,
                saleDept: saleDept,
                kpiHunterTypeId: kpiHunterTypeId,
                coeffList: coeffList,
              })
            );
          }}
        />
      </Box>
      <Box sx={{ minWidth: 200 }}>
        <FormControl fullWidth>
          <InputLabel htmlFor="ceof-select" shrink>
            Тип коэффициента
          </InputLabel>
          <NativeSelect
            value={type || ""}
            onChange={handleChange}
            inputProps={{
              name: "coeff",
              id: "ceof-select",
            }}
          >
            {state.map((el) => {
              return (
                <option value={el.sale_koef_type_id} key={el.sale_koef_type_id}>
                  {el.sale_koef_type_name}
                </option>
              );
            })}
          </NativeSelect>
        </FormControl>
      </Box>

      <Box sx={{ minWidth: 200 }}>
        <FormControl fullWidth>
          <InputLabel htmlFor="hunter-type-select" shrink>
            Тип хантера
          </InputLabel>
          <NativeSelect
            value={kpiHunterTypeId || ""}
            onChange={handleChange}
            inputProps={{
              name: "kpi_hunter_type_id",
              id: "hunter-type-select",
            }}
          >
            {hunterTypes.map((el) => {
              return (
                <option value={el.kpi_hunter_type_id} key={el.kpi_hunter_type_id}>
                  {el.type_name}
                </option>
              );
            })}
          </NativeSelect>
        </FormControl>
      </Box>

      {position_code === "SALE_HEAD_HEAD" ||
      position_code === "SALE_AUDITOR" ? (
        <FormControl style={{ minWidth: "200px" }}>
          <InputLabel htmlFor="select-sd" shrink>
            ОП
          </InputLabel>
          <NativeSelect
            value={saleDepartmentId || ""}
            onChange={handleChange}
            inputProps={{
              name: "sale_department_id",
              id: "select-sd",
            }}
          >
            {saleDept.map((el) => {
              return (
                <option
                  value={el.sale_department_id}
                  key={el.sale_department_id}
                >
                  {el.sale_department_name}
                </option>
              );
            })}
          </NativeSelect>
        </FormControl>
      ) : null}
    </Box>
  );
};

export default Filters;
